import { Menu, Ticket, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { siteConfig } from "../config/site";

const navigation = [
  { label: "Home", to: "/" },
  { label: "Tickets", to: "/tickets" },
  { label: "Event Info", to: "/#event-info" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact", to: "/contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`site-header ${solid ? "is-solid" : ""}`}>
      <div className="container header-inner">
        <Link className="brand" to="/" aria-label={`${siteConfig.brandName} home`}>
          <img
            className="brand-logo"
            src="/images/rp-logo.png"
            alt=""
            width="42"
            height="42"
            aria-hidden="true"
          />
          <span>{siteConfig.brandName}</span>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {navigation.map((item) => (
            <NavLink key={item.label} to={item.to} onClick={() => setOpen(false)}>{item.label}</NavLink>
          ))}
        </nav>
        <Link className="button button-primary header-cta" to="/tickets">
          <Ticket size={17} aria-hidden="true" /> Explore tickets
        </Link>
        <button
          className="menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="mobile-navigation"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>
      <nav id="mobile-navigation" className={`mobile-nav ${open ? "is-open" : ""}`} aria-label="Mobile navigation">
        {navigation.map((item) => <NavLink key={item.label} to={item.to} onClick={() => setOpen(false)}>{item.label}</NavLink>)}
        <Link className="button button-primary" to="/tickets" onClick={() => setOpen(false)}>Explore tickets</Link>
      </nav>
    </header>
  );
}
